const Owl = {
	bind: function () {
		
	},
	inserted: function (el, viewOptions) {
		const sampleOptions = {
			autoplay: true,
			autoplayTimeout: 8000,
			items: 1,
			dots: false,
			mouseDrag: true,
			rewind: true,
			center: true,
			lazyContent: true,
			nav: false,
			loop: false
		}

		var options = Object.assign({}, sampleOptions, viewOptions.value)

		$(el).owlCarousel(options)
	}
}

const OwlNext = {
	inserted: function (el, binding) {
		
		var next = function () {
			let slider = binding.value.slider

			$(slider).trigger('next.owl.carousel');
		}

		el.addEventListener('click', next)
	}
}

const OwlPrev = {
	inserted: function (el, binding) {
		var prev = function () {
			let slider = binding.value.slider

			$(slider).trigger('prev.owl.carousel');
		}

		el.addEventListener('click', prev)
	}
}
export { Owl, OwlNext, OwlPrev }